import { useEffect } from "react";
import { useState, createContext } from "react";
import axiosInstance from "../Api/Instance";
import { useSelector } from "react-redux";
export const CandidateContext = createContext();

export const DataProvider = ({ children, userId }) => {
  const [isJDChecked, setIsJDChecked] = useState(false);
  const [applied_position, setApplied_position] = useState('');
  const [application_status, setApplication_status] = useState('');
  const [formValue, setFormValue] = useState('');
  const [isEditRemarksOpen, setIsEditRemarksOpen] = useState(false);
  const [isMultipleResumeUpload, setIsMultipleResumeUpload] = useState(true);
  const [notificationSeen, setIsNotificationSeen] = useState(false)
  const [positions, setPositions] = useState([]);
  const [applicant_status, setApplicant_status] = useState([
    { label: "Profile Added", color: "#9e9e9e" },
    { label: "Applied", color: "#42a5f5" },
    { label: "Under Review", color: "#ffb74d" },
    { label: "Shortlisted", color: "#7e57c2" },
    { label: "Interview Scheduled", color: "#4db6ac" },
    { label: "Interview Completed", color: "#64b5f6" },
    { label: "Offer Extended", color: "#81c784" },
    { label: "Offer Accepted", color: "#4caf50" },
    { label: "Offer Declined", color: "#e57373" },
    { label: "Rejected", color: "#f44336" },
    { label: "On Hold", color: "#ffeb3b" },
    { label: "Hired", color: "#2e7d32" },
    { label: "Withdrawn", color: "#757575" },
  ]);

  const role = useSelector(state=>state.auth?.user?.role);
  const [errorInResume, setErrorInResume] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
useEffect(() => {
 console.log()
  const fetchRoles = async () => {
    if(role !=='admin') return;
    try {
      const response = await axiosInstance.get('/getCandidateRoles');
      const data = response.data;
      console.log("Fetched roles data:", data);

      if (Array.isArray(data.roles)) {
        setPositions(data.roles);
      } else {
        console.error("Expected 'roles' to be an array but got:", data.roles);
      }
    } catch (err) {
      console.error("Failed to fetch roles:", err.response?.data?.message || err.message);
    }
  };

  fetchRoles();
}, [role]);
  const handleClose = () => setSnackbarOpen(false)
  return (
    <CandidateContext.Provider value={{ isJDChecked, userId, setIsJDChecked, applied_position, setApplied_position, positions, setPositions, application_status, setApplication_status, applicant_status, setApplicant_status, formValue, setFormValue, isEditRemarksOpen, setIsEditRemarksOpen, isMultipleResumeUpload, setIsMultipleResumeUpload, notificationSeen, setIsNotificationSeen, errorInResume, setErrorInResume, handleClose, snackbarOpen, setSnackbarOpen, positions, setPositions }}>
      {children}
    </CandidateContext.Provider>)
}

